/**
 * «Сайт» — `GET /api/metrika/report`: копия Яндекс Метрики по месяцам, среднее в день.
 * Спека `docs/specs/2026-09-30-metrika-design.md`.
 */
import { apiFetch } from "@/lib/api";

export type Metric = "visits" | "engaged" | "contacts";

export type MetrikaRow = {
  key: string;
  label: string;
} & Record<Metric, number[]> &
  Record<`${Metric}_base` | `${Metric}_delta`, number>;

export type MetrikaReport = {
  counter: number;
  slice: string;
  slices: { code: string; label: string }[];
  to: string;
  base_months: number;
  sort_by: Metric;
  months: { month: string; label: string; days: number }[];
  total: MetrikaRow;
  rows: MetrikaRow[];
  rows_total: number;
};

export const loadMetrika = (slice: string, months: number) =>
  apiFetch<MetrikaReport>(`/api/metrika/report?${new URLSearchParams({ slice, months: String(months) })}`);
